import { logError } from 'utils/errorLogging';

export interface StreamingChunk<T> {
  id: number | undefined;
  data: T;
}

export class PlatformStreamParser<T> {
  private onChunkCallback: (chunk: StreamingChunk<T>) => void;
  private buffer = '';

  constructor(onChunkCallback: (chunk: StreamingChunk<T>) => void) {
    this.onChunkCallback = onChunkCallback;
  }

  public pushContent(content: string): void {
    this.buffer += content;
    this.processBuffer();
  }

  private processBuffer(): void {
    let separatorIndex;

    while ((separatorIndex = this.buffer.indexOf('\n\n')) !== -1) {
      const chunkStr = this.buffer.substring(0, separatorIndex);
      this.buffer = this.buffer.substring(separatorIndex + 2); // Consume chunk and separator

      const lines = chunkStr.split('\n').filter(line => line.length > 0);

      const idLine = lines.find(line => line.startsWith('id: '));
      const dataLine = lines.find(line => line.startsWith('data: '));

      if (!dataLine) {
        console.warn('Invalid chunk', chunkStr);
        continue;
      }

      const id = idLine ? Number(idLine.substring('id: '.length)) : undefined;
      const dataStr = dataLine.substring('data: '.length);

      try {
        const data = JSON.parse(dataStr);
        this.onChunkCallback({ id, data });
      } catch (e) {
        logError(e);
        console.warn('Invalid chunk data', dataStr);
      }
    }
  }
}
